export const AwaitingTemplate = {
    name: 'awaiting',
    label: 'Awaiting payment',
    subject: "REBIT ${reference}: New order received!",
    category: 'compulsory',
    body: "<p>👏🏼 Well done, ${payer_name}</p>"
        + "<p>✅ Your <b>Rebit: ${reference}</b> to ${recipient_name} is submitted.</p>"
        + "<p>📤 <b>You pay: ${paid_amount} ${origin_currency} (Including fees/discount)</b></p>"
        + "<p>📥 <b>They'll receive: ${received_amount} ${dest_currency}</b></p>"
        + "<p>⌚ <b>Estimated transfer time: ${transfer_time};</b> More details in <a href='https://my.rebitmoney.com/help-and-support/tracking'>Help & Support - Tracking</a></p>"
        + "<p style='padding:10px;background-color:#fffae6'>⚠️ If you haven't made the bank payment yet, please click below to complete your payment immediately.<br>"
        + "☁️ You can also upload bank receipts via Tracking or Payment.</p>"
        + "<p style='padding:20px;text-align: center'>"
        + "<a href='https://my.rebitmoney.com/transfers/pay?ref=${reference}' style='padding:10px;background-color: #000000;color: white;border-radius: 4px;text-decoration: none'>PAY ${paid_amount} <span style='font-size: 0.7rem'>${origin_currency}</span> NOW</a>"
        + "</p>"
        + "<p>⏲ A bank transfer usually takes as long as a transfer between banks. It can take a few hours on weekdays or a few days over weekends and public holidays.</p>"
        + "<p>⏳ We’ll process your order as soon as we receive your payment.</p>"
}

